var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("custom-dialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.tsg("selectCamera")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        attrs: { cols: "11", align: "left" },
                      },
                      [
                        _vm.cameraList.length > 0
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: {
                                  "max-height": "60vh",
                                  "overflow-y": "auto",
                                },
                              },
                              _vm._l(_vm.cameraList, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-2",
                                    attrs: { cols: "4" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cgs_thumb",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectCamera(item)
                                          },
                                        },
                                      },
                                      [
                                        item.offline
                                          ? _c(
                                              "div",
                                              { staticClass: "cgs_state_box" },
                                              [_vm._v(_vm._s(_vm.t("offline")))]
                                            )
                                          : item.thumbnailSrc &&
                                            !item.imageError
                                          ? _c("img", {
                                              staticClass: "cgs_img",
                                              attrs: { src: item.thumbnailSrc },
                                              on: {
                                                error: function ($event) {
                                                  return _vm.onThumbError(index)
                                                },
                                              },
                                            })
                                          : item.imageError
                                          ? _c("div", {
                                              staticClass: "cgs_state_box",
                                            })
                                          : _c("v-skeleton-loader", {
                                              staticClass: "cgs_skeleton",
                                              attrs: {
                                                type: "image",
                                                dark: "",
                                                boilerplate: false,
                                                elevation: "0",
                                              },
                                            }),
                                        _c(
                                          "div",
                                          { staticClass: "cgs_name ellipsis" },
                                          [_vm._v(_vm._s(item.cameraName))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-10",
                                attrs: {
                                  cols: "12",
                                  align: "center",
                                  id: "cgs_nodata",
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }